<template>
  <div class='flexC' @mouseover="overM" @mouseout="overO">
    <svg class='posA ani' :class='[{overf:overf},sizeWH
    ]' viewBox="0 0 200 200">
      <!-- <circle cx="10" cy="10" r="3" fill="none" stroke="green" stroke-width="6" id="circle" style="transform: translateX(80px);" class="circleView" /> -->
      <circle cx="100" cy="100" r="74" fill="none" stroke="#e1e1e1" stroke-width="12" />
      <circle cx="100" cy="100" r="74" fill="none"  class='svgPie'  stroke-dasharray="465" :stroke-dashoffset="dashoffset" stroke-linecap="round" />
      <!-- <circle cx="100" cy="120" r="74" fill="none" stroke="green" stroke-width="12" stroke-dashoffset="464.5" stroke-dasharray="465" stroke-linecap="round" id="circleInner" style="transform:rotate(.8783783783783784rad); transform-origin: 100px 120px;" />    -->
    </svg>
    <div v-if="InlineBlock">
      {{!isnull?'--':percent+'%'}}
    </div>
    <div v-else class="taC">
      <p class='cMain '>{{!isnull?'--':percent}}</p>
      <p class='cMain' v-if='isnull'>%</p>
    </div>
  </div>
</template>
<script>
import * as lib from '@/util/lib'
import { getLanguageStr } from '@/util/language'

export default {
  name: '',
  components: {},
  props: {
    percent: {
      type: Number,
      default: 0
    },
    isnull: {
      type: Boolean,
      default: false
    },
    sizeWH:{
      type:String,
      default:'w5x h5x'
    },
    InlineBlock:{
      type: Boolean,
      default: false
    }
  },
  watch: {
    percent (val) {
      this.sum(val)
    }
  },
  data () {
    return {
      dashoffset: 465,
      overf:false
    }
  },
  methods: {
    getLanguageStr,
    sum (val) {
     
      this.dashoffset = ((100 - val) * 465)/100
    },
    overM () {
      this.overf = true
    },
    overO () {
 this.overf = false
    }

  },
  computed: {
  },
  created () { },
  mounted () {
    this.sum(this.percent)
  }
}
</script>
<style lang="scss" scoped>
.svgPie{
  stroke: $primary;
  stroke-width: 12
}
.flexC{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column
}
.cMain{
  margin-bottom: 0px
}
.ani {
  .svgPie{
    // transition: .5s cubic-bezier(0.13, -0.3, 0.79, 1.35);
    transform-origin: 100px 100px;
    transform:rotate(-90deg)
   
  }
  // &.overf{
  //   .svgPie{
  //   transform:rotate(-450deg);
  //   stroke-width: 20
  // }
  // }
  
}
</style>



// WEBPACK FOOTER //
// src/components/common/Svgpie.vue